import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import PreviewButton from '../../PreviewButton';
import { AlertCircle } from 'lucide-react';

const SendToSection = ({
  formData,
  handleInputChange,
  errors,
  sendToOptions,
  templateData,
  handleTemplatePreview,
  templateValidationMessage,
  isDark
}) => {
  return (
    <>
      <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
        isDark ? 'bg-[#000000]' : 'bg-white'
      } ${errors.sendTo ? 'border-[#FF0000]' : ''}`}>
        {/* Header */}
        <div className="flex items-center justify-between">
          <span className={`text-[16px] font-semibold transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>
            Send to: <span className="text-[#FF0000]">*</span>
          </span>
          <div className="ml-auto">
            {templateData.length > 0 && formData.sendTo && (
              <PreviewButton
                onClick={() => handleTemplatePreview('sendTo')}
                tooltip="Preview all templates for selected recipients"
                isDark={isDark}
              />
            )}
          </div>
        </div>

        {/* Radio options */}
        <RadioGroup
          value={formData.sendTo || ''}
          onValueChange={(value) => {
            handleInputChange('sendTo', value);
          }}
          className="flex flex-col gap-[16px]"
        >
          {sendToOptions.map((option) => (
            <label 
              key={option.value}
              className={`flex items-center gap-[8px] cursor-pointer transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
              }`}
              htmlFor={`sendTo-${option.value.replace(/\s+/g, '-').toLowerCase()}`}
            >
              <RadioGroupItem 
                value={option.value} 
                id={`sendTo-${option.value.replace(/\s+/g, '-').toLowerCase()}`}
              />
              <span className={`text-[16px] font-normal transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
              }`}>
                {option.name}
              </span>
            </label>
          ))}
        </RadioGroup>
      </div>

    {/* Error messages */}
    {errors.sendTo && (
      <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
        <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
        <span className="leading-[1.4]">You are required to fill this answer</span>
      </div>
    )}
    {errors.sendToValidation && (
      <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
        <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
        <span className="leading-[1.4]">{templateValidationMessage}</span>
      </div>
    )}
    </>
  );
};

export default SendToSection;

